import { inject } from "aurelia";
import { ApiClient } from "./api-client";

@inject(ApiClient)
export class AuthService {
  constructor(http) {
    this.http = http;
  }

  authenticate(username, password, customer) {
    return new Promise((resolve, reject) => {
      this.http
        .post("v1/auth", { username, password, customer })
        .then((data) => JSON.parse(data.response))
        .then((response) => {
          return resolve(response);
        })
        .catch((e) => reject(e));
    });
  }

  async verifyMfa(mfaToken, code) {
    return new Promise((resolve, reject) => {
      this.http
        .post("/v1/auth/mfa/verify", {
          mfaToken: mfaToken,
          code: code
        })
        .then((data) => JSON.parse(data.response))
        .then((response) => {
          return resolve(response);
        })
        .catch((e) => reject(e));
    });
  }

  refresh(token) {
    return new Promise((resolve, reject) => {
      this.http
        .post("v1/auth/refresh", { token: token })
        .then((data) => JSON.parse(data.response))
        .then((response) => {
          return resolve(response);
        })
        .catch((e) => reject(e));
    });
  }
}
